import React from 'react';
import './CollectionCardSkeleton.scss';

const CollectionCardSkeleton: React.FC = () => {
  return (
    <div className="collection-card-skeleton">
      <div className="skeleton skeleton--title"></div>
      <div className="skeleton skeleton--description"></div>
      <div className="skeleton skeleton--stats"></div>
    </div>
  );
};

export default CollectionCardSkeleton;
